<template>
  <div id="app">
    <Calculator />
    <!-- Mount the calculator component -->
  </div>
</template>

<script>
import Calculator from "./components/calculator.vue"; // Import the Calculator component

export default {
  name: "App",
  components: {
    Calculator, // Register the Calculator component
  },
};
</script>

<style>
/* Add your global styles here */
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
}
</style>


